import {createReducer} from "redux-act";
import {
	fetchContextualPromptSuccess,
	fetchContextualPromptError,
	openContextualPrompt,
	closeContextualPrompt,
	declineContextualPrompt,
} from "modules/actions";
import {IContextualPromptBannerReducer} from "modules/types";

const initialState: IContextualPromptBannerReducer = {
	prompt: [],
	isOpen: false,
};

export const contextualPrompt = createReducer({}, initialState)
	.on(fetchContextualPromptSuccess, (state: IContextualPromptBannerReducer, payload) => {
		if (!payload) {
			return state;
		}
		return {
			...state,
			prompt: [...state.prompt, payload],
		};
	})
	.on(fetchContextualPromptError, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			prompt: [],
		};
	})
	.on(declineContextualPrompt, (state: IContextualPromptBannerReducer, payload) => {
		if (!payload) {
			return state;
		}
		return {
			...state,
			prompt: state.prompt.filter((item) => item.game !== payload.game),
		};
	})
	.on(openContextualPrompt, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			isOpen: true,
		};
	})
	.on(closeContextualPrompt, (state: IContextualPromptBannerReducer) => {
		return {
			...state,
			isOpen: false,
		};
	});
